import { fetcher } from '@commenda/utils';
import { TGenerateResult } from './types';

type GenerateTPDocumentResult =
  | { ok: true; data: TGenerateResult }
  | { ok: false; error: string };

const generateTPDocument = async (
  recordId: string
): Promise<GenerateTPDocumentResult> => {
  const res = await fetcher(`tp-document-record/${recordId}/generate`, {
    method: 'POST',
    body: {},
  });

  if (!res.ok) {
    return { ok: false, error: 'Failed to generate document' };
  }

  const data = (await res.json()) as TGenerateResult;
  return { ok: true, data };
};

export { generateTPDocument };
export type { GenerateTPDocumentResult };
